var postcssJs = {
    objectify: require('./objectifier'),
    parse:     require('./parser'),
    async:     require('./async'),
    sync:      require('./sync')
};
module.exports = postcssJs;



/*****************
 ** WEBPACK FOOTER
 ** ./~/postcss-js/index.js
 ** module id = 456
 ** module chunks = 0
 **/